import './RegStyle.css';
import RegEngine from './RegEngine';
import Footer from '../Footer';
import Header from '../Header';


function RegSito(props) {

	return (
		<>
			<Header />
			<div className="iol-lrcp-wrapper row reg-row">
				<div className="iol-lrcp-text-wrapper col-xl-6">
					<h1 className="large-title fucsia-text">Crea un account</h1><p className="heading-5">Scopri il servizio in prova gratuita per la creazione di un sito web.</p>
				</div>
				<RegEngine />
			</div>
			<Footer pageTitle="Registrazione Sito" />
		</>
	);
}

export default RegSito;
